import { useState, useEffect } from 'react';

export default function useDependableState (initialValue, dependencies = []) {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, dependencies);
  return [value, setValue];
};
